import { MainNavigation } from '@asset-metrix/portal-ui';

import { useStore } from '../../store';
import { pixelSizeHelperPortalUi } from '../../utils/pixelSizeHelperPortalUi';

import { useNavigationContext } from './NavigationContext';

type ApplicationNavSectionProps = { isPending?: boolean };

export const ApplicationNavSection = ({
  isPending,
}: ApplicationNavSectionProps) => {
  const {
    activeMainItemIndex,
    navItems,
    handleClick,
    isPending: isNavigationPending,
  } = useNavigationContext();
  const collapsed = useStore((state) => state.isNavigationCollapsed);

  if (!navItems || navItems.length === 0) {
    return null;
  }
  return (
    <MainNavigation
      activeItemIndex={activeMainItemIndex}
      collapsed={collapsed}
      collapsedTooltipWidth={`${pixelSizeHelperPortalUi(200)}px`}
      items={navItems}
      onClick={handleClick}
      isPending={isPending || isNavigationPending}
    />
  );
};
